import { z } from "zod";

const normalizeDomainString = (domain: string): string => {
  let normalized = domain.trim();
  const atIndex = normalized.indexOf("@");
  if (atIndex >= 0) {
    normalized = normalized.slice(atIndex + 1);
  }
  return normalized.toLowerCase();
};

export const NetworkDomainSchema = z
  .string()
  .transform((raw, ctx) => {
    if (!raw || raw.trim() === "") {
      ctx.addIssue({
        code: 'custom',
        message: "Network domain must have a value.",
      });
      return z.NEVER;
    }

    return normalizeDomainString(raw);
  })
  .superRefine((normalized, ctx) => {
    const labels = normalized.split(".");
    const labelPattern = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

    const invalid =
      labels.length < 2 ||
      labels.some((label, idx) => {
        if (idx === labels.length - 1) {
          // Final label (TLD)
          return label.length < 2 || !labelPattern.test(label);
        } else {
          // Other labels
          return label.length < 1 || !labelPattern.test(label);
        }
      });

    if (invalid) {
      ctx.addIssue({
        code: 'custom',
        message:
          "Network domain is not valid: should be in the format 'example.com'.",
      });
    }
  });
  
